import { render } from "./FiltersComponent.vue?vue&type=template&id=5d5cf184&scoped=true&ts=true"
import script from "./FiltersComponent.vue?vue&type=script&lang=ts"
export * from "./FiltersComponent.vue?vue&type=script&lang=ts"

import "./FiltersComponent.vue?vue&type=style&index=0&id=5d5cf184&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5cf184"]])

export default __exports__